import VueI18n from 'vue-i18n'
import enMessage from './locales/en.message'
import jaMessage from './locales/ja.message'
import Vue from 'vue'
import { store } from '../stores'

Vue.use(VueI18n)

const messages = {
  'en': enMessage,
  'jp': jaMessage
}

const i18n = new VueI18n({
  locale: store.getters['account/localLang'] || 'jp',
  messages, // set locale messages
})


export default i18n
export const languages = [
  {
    locale: 'en', backendRecord: 'en', bc47Code: 'en-US', icon: '/img/lang-en-us.svg', title: 'English', backendLocale: 'en'
  },
  {
    locale: 'jp', backendRecord: 'jp', bc47Code: 'ja-JP', icon: '/img/lang-jp-ja.svg', title: '日本語', backendLocale: 'ja'
  }
]
